'use strict';

import type { UserSavedReport } from '../../Entities/User/UserSavedReport';
import { EntityCollection } from '../EntityCollection';

export class UserSavedReportCollection extends EntityCollection<UserSavedReport> {}
